import { Component, OnInit } from '@angular/core';

import { ComponentBase } from '@definitiv-packages/angular-dba-library';

import { DebitorModel, DebitorService, ProjectLanguage } from '../../../../../roofsafetymanagement-library/src/public-api';

@Component({
  selector: 'app-debtor-list-view',
  templateUrl: './debtor-list-view.component.html',
  styleUrl: './debtor-list-view.component.scss',
  standalone: false
})
export class DebtorListViewComponent extends ComponentBase<ProjectLanguage> implements OnInit {
  public debtorList: DebitorModel[] = [];

  constructor(
    private debtorService: DebitorService
  ) { super(); }

  public async ngOnInit(): Promise<void> {
    try {
      this.loading = true;
      this.debtorList = await this.debtorService.getFilteredList();
    } finally {
      this.loading = false;
    }
  }
}
